import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { LoadScript } from "@react-google-maps/api";
import Root from "./routes/root";
import InteractiveMap from "./routes/InteractiveMap";

import { atom } from "jotai";

const state = { followingForm: false };
const routerBasename = (window as any).OGT?.WebApp?.routerBasename ?? "";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <Root />,
      children: [
        {
          index: true,
          element: <InteractiveMap />,
          loader: () => {
            state.followingForm = true;
            return null;
          },
        },
      ],
    },
  ],
  { basename: routerBasename }
);

const pagePaths =
  (router?.routes[0]?.children
    ?.map((child) => child.path)
    .filter(Boolean) as string[]) || [];
export const pageCountAtom = atom({ pagePaths });

const GMAP_LIBRARIES: "geometry"[] = ["geometry"];

const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

function App() {
  return (
    <LoadScript
      googleMapsApiKey={googleMapsApiKey}
      version="3.61"
      libraries={GMAP_LIBRARIES}
      id="google-maps-script"
    >
      <RouterProvider router={router} />
    </LoadScript>
  );
}

export default App;
